import { View, ViewGenerator, ViewModel } from "binder";
import { TabItemContainerViewModel } from "./tabItemContainer-viewModel"

export class TabItemContainerView extends View<TabItemContainerViewModel>{
    GetViewUniqueId(): string {
        return "V-B2D9F2FF-11D2-42E2-B018-C3C207701A2E"
    }
    loadHtml(): string {
        let element = require('./tabItemContainer.html').default;
        let style = require('./tabItemContainer.less');
        return element;
    }
    constructor() {
       super();
    }

    public set element(v: ViewModel) { this._element = v; } public get element(): ViewModel { return this._element;} private _element: ViewModel;
    public set headerViewTemplate(v: Node) { this._headerViewTemplate = v; } public get headerViewTemplate(): Node { return this._headerViewTemplate;} private _headerViewTemplate: Node;
    public set isselected(v: boolean) { 
        this._isselected = v; 
        if(this.firstlevelElement)
            (<HTMLElement>this.firstlevelElement).scrollIntoView();
    } public get isselected(): boolean { return this._isselected;} private _isselected: boolean;

    tabViewSelector(v){
        return ViewGenerator.GetNodeByTemplate(v,this.headerViewTemplate);
    }
    select(){
        this.dataContext.select();
    }
    public onRenderCompleted() {
        if(this.isselected)
            (<HTMLElement>this.firstlevelElement).scrollIntoView();
    }
}
